import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ label = 'Back', className = '', onClickRedirect }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClickRedirect) {
      // If onClickRedirect prop is passed, call it
      onClickRedirect();
    } else {
      // If no redirect handler is passed, use the default back navigation
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center text-gray-600 hover:text-gray-800 transition-colors ${className}`}
    >
      <ArrowLeft className="h-5 w-5 mr-2" />
      {label}
    </button>
  );
};

export default BackButton;
